// We can use this method to split a single array into two single arrays
// by providing a condition. Check EnrollmentPathway.js

export function partition(array, filter) {
  const pass = []
  const fail = []
  array.forEach((e) => (filter(e) ? pass : fail).push(e))
  return [pass, fail]
}
